import type { ManagerOptions, SocketOptions } from 'socket.io-client';

export const socketIOSettings: Partial<ManagerOptions & SocketOptions> = {
  path: '/sockets',
  secure: true,
  transports: ['websocket'],
};
